import { CsEnNazev, CsEnPopis, DateTime } from "b2b/renderers";

export const nazev = () => ({
  id: "nazev",
  label: "b2b.projekty-grid-columns.nazev.label",
  path: "",
  renderer: CsEnNazev
});

export const popis = () => ({
  id: "popis",
  label: "b2b.projekty-grid-columns.popis.label",
  path: "",
  renderer: CsEnPopis
});

export const smlouva = () => ({
  id: "smlouva",
  label: "b2b.projekty-grid-columns.smlouva.label",
  path: "smlouva.cislo"
});

export const vytvoril = () => ({
  id: "vytvoril",
  label: "b2b.projekty-grid-columns.vytvoril.label",
  path: "vytvoril.username"
});

export const upravil = () => ({
  id: "upravil",
  label: "b2b.projekty-grid-columns.upravil.label",
  path: "upravil.username"
});

export const datumUprava = () => ({
  id: "datumUprava",
  label: "b2b.projekty-grid-columns.datumUprava.label",
  path: "datumUprava",
  renderer: DateTime
});

export const datumVytvoreni = () => ({
  id: "datumVytvoreni",
  label: "b2b.projekty-grid-columns.datumVytvoreni.label",
  path: "datumVytvoreni",
  renderer: DateTime
});
